function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u2705-Project",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Baner-cookies",
  transform: "translate(-843.000000, -1046.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(813.000000, 1017.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "New-Icon/Contract",
  transform: "translate(30.000000, 29.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 21,
  height: 21
}), /*#__PURE__*/React.createElement("g", {
  id: "umowa",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#48A9A1",
  opacity: 0.2,
  x: 2.352,
  y: 0.3045,
  width: 14.2275,
  height: 18.9,
  rx: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5845,20.622 L1.407,20.622 C1.11705051,20.622 0.882,20.3869495 0.882,20.097 L0.882,2.247 C0.882,1.95705051 1.11705051,1.722 1.407,1.722 L14.5845,1.722 C14.8721039,1.72758611 15.1039139,1.95939612 15.1095,2.247 L15.1095,4.9665 C15.1039139,5.25410388 14.8721039,5.48591389 14.5845,5.4915 C14.2945505,5.4915 14.0595,5.25644949 14.0595,4.9665 L14.0595,2.772 L1.932,2.772 L1.932,19.572 L14.0595,19.572 L14.0595,14.5005 C14.0595,14.2105505 14.2945505,13.9755 14.5845,13.9755 C14.8744495,13.9755 15.1095,14.2105505 15.1095,14.5005 L15.1095,20.097 C15.1095,20.3869495 14.8744495,20.622 14.5845,20.622 Z",
  id: "Path",
  fill: "#555150"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.198,14.6055 L3.843,14.6055 C3.55305051,14.6055 3.318,14.3704495 3.318,14.0805 C3.318,13.7905505 3.55305051,13.5555 3.843,13.5555 L9.198,13.5555 C9.48794949,13.5555 9.723,13.7905505 9.723,14.0805 C9.71741389,14.3681039 9.48560388,14.5999139 9.198,14.6055 Z",
  id: "Path",
  fill: "#48A9A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.2325,17.85 L8.5365,17.85 C8.24655051,17.85 8.0115,17.6149495 8.0115,17.325 C8.0115,17.0350505 8.24655051,16.8 8.5365,16.8 L12.2325,16.8 C12.5201039,16.8055861 12.7519139,17.0373961 12.7575,17.325 C12.7575,17.4642387 12.7021877,17.5977745 12.6037311,17.6962311 C12.5052745,17.7946877 12.3717387,17.85 12.2325,17.85 Z",
  id: "Path",
  fill: "#48A9A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.912,12.39 L3.843,12.39 C3.55305051,12.39 3.318,12.1549495 3.318,11.865 C3.318,11.5750505 3.55305051,11.34 3.843,11.34 L9.912,11.34 C10.2019495,11.34 10.437,11.5750505 10.437,11.865 C10.437,12.0042387 10.3816877,12.1377745 10.2832311,12.2362311 C10.1847745,12.3346877 10.0512387,12.39 9.912,12.39 Z",
  id: "Path",
  fill: "#48A9A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.235,10.2165 L3.885,10.2165 C3.59505051,10.2165 3.36,9.98144949 3.36,9.6915 C3.36,9.40155051 3.59505051,9.1665 3.885,9.1665 L11.235,9.1665 C11.5249495,9.1665 11.76,9.40155051 11.76,9.6915 C11.76,9.98144949 11.5249495,10.2165 11.235,10.2165 Z",
  id: "Path",
  fill: "#48A9A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.2325,8.0115 L3.8325,8.0115 C3.54255051,8.0115 3.3075,7.77644949 3.3075,7.4865 C3.3075,7.19655051 3.54255051,6.9615 3.8325,6.9615 L12.2325,6.9615 C12.5224495,6.9615 12.7575,7.19655051 12.7575,7.4865 C12.7519139,7.77410388 12.5201039,8.00591389 12.2325,8.0115 Z",
  id: "Path",
  fill: "#48A9A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.2325,5.796 L3.8325,5.796 C3.54255051,5.796 3.3075,5.56094949 3.3075,5.271 C3.3075,4.98105051 3.54255051,4.746 3.8325,4.746 L12.2325,4.746 C12.5224495,4.746 12.7575,4.98105051 12.7575,5.271 C12.7519139,5.55860388 12.5201039,5.79041389 12.2325,5.796 Z",
  id: "Path",
  fill: "#48A9A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.572,1.05 C19.0295562,0.729818012 18.330349,0.908139314 18.0075,1.449 L12.054,11.55 C10.857,13.587 10.4265,15.897 10.7205,16.0755 C11.0145,16.254 12.8205,14.7525 14.028,12.705 L19.95,2.625 C20.1089522,2.36607291 20.1584276,2.05456903 20.0875233,1.75913442 C20.016619,1.4636998 19.8311543,1.20858154 19.572,1.05 Z",
  id: "Path",
  fill: "#48A9A1"
}))))));

var SvgContract = function SvgContract(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContract, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Contract.a233b4e7.svg";
export { ForwardRef as ReactComponent };